export default __webpack_public_path__ + "static/media/configr.b9e789ee.svg";